<template>
  <div class="login-container">
    <div class="background"></div>
    <div class="login-form">
      <img class="logo" src="../assets/images/logo.png">
      <div class="div_appletLoginQrCodeLoginArea" style="display: block;">
        <div v-if="expiration" class="div_qr_mask">
          <div>
            <img class="svg_icon" src="../assets/images/icon_success.png">
          </div>
          <p id="p_firstMsg" style="font-size: 18px; font-weight: 600; ">小程序码已过期!</p>
          <a id="a_refresh" style="color: aliceblue;" href="javascript:void(0);" @click="refreshMiniProgramCode">
            <p id="p_secondMsg" style="padding-top: 10px; letter-spacing: 0; text-align: center; line-height: 28px;">
              点击刷新</p>
          </a>
        </div>
        <div v-else-if="loginStatus" class="div_qr_mask" style="">
                        <div>
                            <img class="svg_icon" src="../assets/images/icon_success.png">
                        </div>
                        <p id="p_firstMsg" style="font-size: 18px; font-weight: 600; ">扫描成功!</p>
                        <a id="a_refresh" style="color: aliceblue;"><p id="p_secondMsg" style="padding-top: 10px; letter-spacing: 0; text-align: center; line-height: 28px;">请在小程序中完成后续操作</p></a>
        </div>

        <img style="width: 220px; height: 220px" v-if="miniProgramCode" :src="miniProgramCode">
        <div v-else style="width: 220px; height: 220px; display: flex; align-items: center; justify-content: center;">
          <i class="el-icon-loading" style="font-size: 32px; color: #12d3f5;"></i>
        </div>

        <div class="scan"><img src="../assets/images/ic_scan.png">打开微信“扫一扫”即可登录</div>
      </div>
      <div class="protocol"><img src="../assets/images/ic_select.png">扫码表示您已经阅读并同意 <a>《用户协议》</a><a>《隐私政策》</a></div>
    </div>
  </div>
</template>

<script>
import { getSessionId, getToken, buildMiniProgramCode, checkLogin } from '@/api/login';
import { getCookie } from '@/utils/cookie';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { setToken } from '../context/authorization'

export default {
  name: 'LoginForm',
  props: {
    msg: String
  },
  data() {
    return {
      fingerPrint: '',
      miniProgramCode: '',
      expiration: false,
      loginStatus: false,
      ExpirationTime: '',
      checkExpirationInterval: null // 存储定时器 ID
    }
  },
  mounted() {
    this.refreshMiniProgramCode();
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.checkExpirationInterval) {
      clearInterval(this.checkExpirationInterval);
    }
  },
  methods: {
    login() {
      console.log('login');
      getSessionId().then((res) => {
        console.log('getToken', res);
        if (res.Code === 0) {
          // 获取名为 'token' 的 cookie
          const sissCloudTokenID = getCookie('SissCloudTokenID');
          if (sissCloudTokenID) {
            console.log('获取到的 token cookie:', sissCloudTokenID);
            getToken().then((res) => {
              console.log('getToken', res);
              // 假设返回的数据中包含 token 字段
              if (res && res.token) {
                localStorage.setItem('token', res.token);
                console.log('Token 已存储:', res.token);
              } else {
                console.log('未获取到有效的 token');
              }
            })

          } else {
            console.log('未找到 token cookie');
          }
        }
      });
    },
    // 检查登录状态
    checkLoginStatus() {
      checkLogin({ fingerPrint: this.fingerPrint, t: +new Date().getTime() }).then((res) => {
        console.log('checkLogin', res);
        if (res.Code === 0) {
          if(res.Data.loginStatus === 1){
            this.loginStatus = true;
          }
          if(res.Data.isLogin){
            clearInterval(this.checkExpirationInterval);
            setToken(res.Data.token);
            sessionStorage.setItem('SessionTokenId', res.Data.TokenId);
            //进入首页
            this.$router.replace('/view-select');
          }
          //this.login();
        }
      })
    },
    // 获取小程序码
    getMiniProgramCode() {
      buildMiniProgramCode({ fingerPrint: this.fingerPrint, t: +new Date().getTime() }).then((res) => {
        console.log('buildMiniProgramCode', res);
        if (res.Code === 0) {
          this.miniProgramCode = "data:image/png;base64," + res.Data.ImgSrc;
          // 过期时间
          this.ExpirationTime = res.Data.ExpirationTime;

          // 清除之前的定时器
          if (this.checkExpirationInterval) {
            clearInterval(this.checkExpirationInterval);
          }

          // 每秒检查一次是否过期
          this.checkExpirationInterval = setInterval(() => {
            this.checkLoginStatus();
            let now = new Date();
            let expirationDate = new Date(this.ExpirationTime);
            if (now > expirationDate) {
              this.expiration = true;
              // 过期后清除定时器
              clearInterval(this.checkExpirationInterval);
            }
          }, 3000);
        }
      })
    },
    // 获取设备指纹
    async getFingerprint() {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      return result.visitorId; // 唯一设备标识
    },
    // 刷新小程序码
    refreshMiniProgramCode() {
      this.expiration = false;
      this.getFingerprint().then(visitorId => {
        this.fingerPrint = visitorId;
        this.getMiniProgramCode();
      });
    }
  },

}

</script>

<style scoped>
.login-container {
  display: flex;
  height: 100vh;
  /* 视口高度 */
}

.background {
  flex: 1;
  background-image: url('/src/assets/images/leftbg.png');
  /* 背景图片路径 */
  background-size: cover;
  background-position: center;
}

.login-form {
  flex: 0.5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.8);
  /* 半透明白色背景 */
}

.login-form h2 {
  margin-bottom: 20px;
}

.logo {
  margin-bottom: 105px;
  width: 311px;
  height: 40px;
}

.login-form input {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  box-sizing: border-box;
}

.login-form .scan {
  margin-top: 25px;
  display: flex;
  justify-content: center;
  /* 水平居中 */
  height: 23px;
  font-size: 16px;
  font-weight: Regular;
  text-align: left;
  color: #282828;

}

.login-form .scan img {
  width: 25px;
  height: 24px;
  justify-content: center;
  align-items: center;
}

.login-form .protocol {
  margin-top: 18px;
  height: 17px;
  font-size: 12px;
  font-weight: Regular;
  text-align: left;
  color: #7a7a7a;
  line-height: 17px;
  display: flex;
  justify-content: center;
  /* 水平居中 */
}

.login-form .protocol a {
  /* padding-left: 2px; */
  color: #12d3f5;
}

.login-form .protocol img {
  width: 17px;
  height: 16px;

}

.login-form button:hover {
  background-color: #0056b3;
}

.div_appletLoginQrCodeLoginArea {
  width: 15rem;
  height: 20rem;
  margin: 0 auto;
  position: relative;
}

.div_qr_mask {
  position: absolute;
  top: 0;
  bottom: 6.2rem;
  right: 0.8rem;
  left: 0;
  opacity: .9;
  background: #0d1c28;
  padding-top: 50px;
  color: #fff;
  font-size: 16px;
  text-align: center;
}
</style>
